import { Info24px } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { CompactItem, CompactLabel, CompactTrackedItem, CompactValue } from "./styles";
import type { MetricCardData } from "./types";

export const CompactMetricItem = ({ title, tooltip, value, valueEndContent, wide }: MetricCardData) => {
    const Wrapper = wide ? CompactTrackedItem : CompactItem;
    return (
        <Wrapper>
            <CompactLabel>
                {title}
                <Tooltip content={tooltip}>
                    <Info24px
                        color={colorsPalettes.carbon[200]}
                        size="sm"
                    />
                </Tooltip>
            </CompactLabel>
            <Flex
                alignItems="center"
                gap="4px"
            >
                <CompactValue>{value ?? "—"}</CompactValue>
                {valueEndContent}
            </Flex>
        </Wrapper>
    );
};
